<template>
  <v-container>
    <g-data-table controller="workflow" :title="module.name">
      <template v-slot:extra_actions="{ item }">
        <v-list-item @click="controller.editSteps(item)">
          <v-list-item-title>Manage Steps</v-list-item-title>
        </v-list-item>
        <v-list-item @click="controller.goToSend(item)">
          <v-list-item-title>Send To Users</v-list-item-title>
        </v-list-item>
      </template>
    </g-data-table>
  </v-container>
</template>

<script>
// import create from "./create";
// import assign from "./assign";

export default {
  components: {
    // create,
    // assign,
  },
  data() {
    return {
      controller: this.get_controller("workflow"),
      list: [],
      module: {},
    };
  },
  computed: {
    systemCode() {
      return this.$route.params.systemCode;
    },
  },
  watch: {
    systemCode() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.module = this.systemModules[this.systemCode];
      this.controller.getWorkflows(this.systemCode);
      // this.fetchData();
    },

    // fetchData() {
    //   let self = this;

    //   self.get(`Workflow/Code?systemCode=${this.systemCode}`).then((r) => {
    //     if (r.data.success) {
    //       self.list = r.data.data;
    //     }
    //   });
    // },
    // edit(item) {
    //   this.$router.push(`/Workflow/${item.systemCode}/Steps/${item.id}`);
    // },
    // deleteItem(item) {
    //   let self = this;

    //   self.$refs.confirmationDialog.showDialog({
    //     title: `Delete ${this.module.name}`,
    //     message: `Are you sure you wish to delete this ${this.module.name}?`,
    //     callback: self.onDeleted,
    //     callbackData: item,
    //   });
    // },
    // onDeleted(data) {
    //   let self = this;

    //   self.delete("Workflow?id=" + data.id).then(() => {
    //     self.list.splice(self.list.indexOf(data), 1);
    //   });
    // },
    // assignUsers(item) {
    //   this.$refs.assign.show(item);
    // },
  },
};
</script>

<style>
</style>